var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{class:{
    resultList: true,
    'resultList--sm': _vm.sm,
  }},_vm._l((_vm.names),function(resultName,key){return _c('li',{key:key,staticClass:"resultItem"},[_vm._v(_vm._s(resultName))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }